import { render, staticRenderFns } from "./SequenceForm.vue?vue&type=template&id=b03b04ae&scoped=true&"
import script from "./SequenceForm.vue?vue&type=script&lang=ts&"
export * from "./SequenceForm.vue?vue&type=script&lang=ts&"
import style0 from "./SequenceForm.vue?vue&type=style&index=0&id=b03b04ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03b04ae",
  null
  
)

export default component.exports